import { defaultStyles } from 'library';
import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    loaderWrapper: {
        position: 'relative',
        width: '100%',
        height: '50vmin',
        backgroundColor: defaultStyles.lighterGrey,
    },
    loader: {
        position: 'absolute',
        left: '50%',
        top: '50%',
        transform: 'translate(-50%, -50%)',
        maxHeight: '30vmin',
    }
});

export default styles;
